/**
 * Empty state shown on the Datasets tab when the collection is in
 * `draft` status (no datasets yet).
 *
 * Copy is verbatim per `feature-spec.md` §2.3. The "Upload Dataset" CTA
 * is wired by the parent — typically to switch the user to the Upload &
 * Configure tab where the wizard lives.
 */

import React from 'react';
import { Upload } from 'lucide-react';

import { Button } from '../../../../../ui/button';

interface Props {
  /** Wired by the parent to switch the active tab to "upload". */
  onUploadDataset?: () => void;
}

const EmptyDatasetsState: React.FC<Props> = ({ onUploadDataset }) => (
  <div
    className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-border/70 bg-card/40 px-4 py-16 text-center"
    data-testid="empty-datasets-state"
  >
    <Upload className="h-10 w-10 text-muted-foreground" aria-hidden="true" />
    <h2 className="mt-3 text-base font-semibold text-foreground">No datasets yet</h2>
    <p className="mt-2 max-w-md text-[13px] leading-relaxed text-muted-foreground">
      Upload your first CSV to start building the gold dataset for this collection.
    </p>
    <Button
      className="mt-4"
      size="sm"
      onClick={onUploadDataset}
      disabled={!onUploadDataset}
    >
      Upload Dataset
    </Button>
  </div>
);

export default EmptyDatasetsState;
